import {
  startOfToday,
  endOfToday,
  endOfMonth,
  startOfMonth,
  sub,
  startOfYear,
  endOfYear,
  differenceInDays,
} from 'date-fns'

import { PromocodeHistoryDisplayByTypeEnum } from '__generatedTypes__/globalTypes'
import { DateOption, DateOptionsEnum, Filters } from './consts'

export const formatDate = (date: Date, end?: boolean) => {
  const year = date.getFullYear()
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const day = date.getDate().toString().padStart(2, '0')
  return `${year}-${month}-${day}T${end ? '23:59:59.999' : '00:00:00.000'}`
}

export const getFilters = (selectedDate: DateOption) => {
  const startOfDay = startOfToday()
  const endOfDay = endOfToday()
  switch (selectedDate.id) {
    case DateOptionsEnum.Today:
      return {
        from: startOfDay,
        to: endOfDay,
      }
    case DateOptionsEnum.Yesterday:
      return {
        from: sub(startOfDay, { days: 1 }),
        to: sub(endOfDay, { days: 1 }),
      }
    case DateOptionsEnum.ThisMonth:
      return {
        from: startOfMonth(startOfDay),
        to: endOfMonth(endOfDay),
      }
    case DateOptionsEnum.LastMonth:
      return {
        from: startOfMonth(sub(startOfDay, { months: 1 })),
        to: endOfMonth(sub(endOfDay, { months: 1 })),
      }
    case DateOptionsEnum.LastTwoMonths:
      return {
        from: startOfMonth(sub(startOfDay, { months: 2 })),
        to: endOfMonth(sub(endOfDay, { months: 1 })),
      }
    case DateOptionsEnum.Last30days:
      return {
        // 30 day back from today
        from: sub(startOfDay, { days: 30 }),
        to: endOfDay,
      }
    case DateOptionsEnum.Last90days:
      return {
        // 90 day back from today
        from: sub(startOfDay, { days: 90 }),
        to: endOfDay,
      }
    case DateOptionsEnum.Last180days:
      return {
        // 180 day back from today
        from: sub(startOfDay, { days: 180 }),
        to: endOfDay,
      }
    case DateOptionsEnum.Last365days:
      return {
        // 365 day back from today
        from: startOfMonth(sub(startOfDay, { months: 11 })),
        to: endOfDay,
      }
    case DateOptionsEnum.ThisYear:
      // current year
      return {
        from: startOfYear(startOfDay),
        to: endOfYear(endOfDay),
      }
    case DateOptionsEnum.LastYear:
      // previous year
      return {
        from: startOfYear(sub(startOfDay, { years: 1 })),
        to: endOfYear(sub(endOfDay, { years: 1 })),
      }
    case DateOptionsEnum.Lifetime:
      // should be overridden in request params
      return {
        from: startOfYear(startOfDay),
        to: endOfYear(endOfDay),
      }
    default:
      return {
        from: startOfDay,
        to: endOfDay,
      }
  }
}

export const getDisplayBy = (selectedDate: DateOption, filters: Filters) => {
  if (selectedDate.id !== DateOptionsEnum.CustomDateRange) {
    return selectedDate.displayBy
  }

  const { from, to } = filters
  const isSameMonth = from.getMonth() === to.getMonth()
  if (isSameMonth || differenceInDays(to, from) <= 30) {
    return PromocodeHistoryDisplayByTypeEnum.DAYS
  }

  return PromocodeHistoryDisplayByTypeEnum.MONTHS
}
